import { Action, ActionReducer, INIT, MetaReducer } from '@ngrx/store'
import { logout } from './auth/auth.actions'

export function clearStateMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action: Action) => {
    if (action.type === logout.type) {
      state = undefined
    }

    return reducer(state, action)
  }
}

export const metaReducers: MetaReducer[] = [clearStateMetaReducer]
